import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса службы дублей (`Duplicates.Contracts/Routes.cs`, ADR-20). Литерал `/api/` законен только в файлах `api/urls.ts` (eslint).
 */
const BASE = '/api/duplicates/v1'
const resource = (resourceId: string) => `${BASE}/resources/${ridSegment(resourceId)}`

export const DUPLICATES_URLS = {
  sources: `${BASE}/sources`,
  scan: (resourceId: string) => `${resource(resourceId)}/scan`,
  scanStop: (resourceId: string) => `${resource(resourceId)}/scan/stop`,
  scanResume: (resourceId: string) => `${resource(resourceId)}/scan/resume`,
  pairs: (resourceId: string) => `${resource(resourceId)}/pairs`,
  pairCopy: (resourceId: string, pairId: number) => `${resource(resourceId)}/pairs/${pairId}/copy`,
  pairNotDuplicate: (resourceId: string, pairId: number) => `${resource(resourceId)}/pairs/${pairId}/not-duplicate`,
  pairReset: (resourceId: string, pairId: number) => `${resource(resourceId)}/pairs/${pairId}/reset`,
  export: (resourceId: string) => `${resource(resourceId)}/export`,
} as const
